import { ItemList } from '../orm/index'
import { get, lowerCase, head, filter, map } from 'lodash'

class CountryList extends ItemList {
    getEntityKey() {
        return "country"
    }

    loadAllCountries() {
        return async (dispatch, getState) => {
            dispatch(this.updatePaginationNumItemsPerPage(1000))
            dispatch(this.fetchListIfNeeded())
        }
    }

    getDefaultCountry() {
        return this.getCountryForCountryCode("us")
    }

    getAllCountryCodes() {
        return map(this.getAllObjects(), (country) => country.country_code)
    }

    getCountryForId(country_id) {
        return this.getObject(country_id)
    }

    getCountryForCountryCode(country_code) {
        return head(filter(this.getAllObjects(), (country) => country.country_code === lowerCase(country_code)))
    }

    getCurrencyCode(country_id) {
        const country = this.getCountryForId(country_id)
        return get(country, "currency_code")
    }

    getCurrencySymbol(country_id) {
        const country = this.getCountryForId(country_id)
        return get(country, "currency_symbol")
    }

    getCountryCode(country_id) {
        const country = this.getCountryForId(country_id)
        return lowerCase(get(country, "country_code"))
    }

    getPaymentGateway(country_id) {
        const country = this.getCountryForId(country_id)
        return lowerCase(get(country, "payment_gateway"))
    }

    findForCountryCode(country_code) {
        return head(filter(this.getObjects(), (x) => x.country_code === country_code))
    }
    
}

export const countryList = new CountryList("country_list_default")
